"use client";

import { ModuleBannerPrimary } from "@lib/types";
import KeyboardArrowRight from "@material-design-icons/svg/outlined/keyboard_arrow_right.svg";
import { motion } from "motion/react";
import Link from "next/link";

import { resolveCtaHref } from "@/components/shared/cta";
import { ResponsiveImage } from "@/components/shared/ResponsiveImage";
import { cn } from "@/lib/ui/cn";

type BannerItemsProps = {
  items: ModuleBannerPrimary["items"];
};

export const BannerItems = ({ items }: BannerItemsProps) => {
  return (
    <div
      className={cn(
        "gap-gap-element-md flex md:grid md:grid-cols-1 lg:grid-cols-2",
        "scrollbar-hide overflow-x-auto md:overflow-visible",
        "-mx-padding-global px-padding-global md:mx-0 md:px-0",
        "touch-action-none",
      )}
    >
      {items?.map((item, index) => {
        return (
          <motion.div
            key={item._key}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", bounce: 0, duration: 2, delay: index * 0.5 }}
            style={{ touchAction: "pan-x" }}
          >
            <Link href={resolveCtaHref(item.linkCta.href)} className="no-underline">
              <div
                className={cn(
                  "min-w-44 md:min-w-full",
                  // spacing and layout
                  "py-padding-element-sm px-padding-element-sm md:px-padding-element-md gap-gap-element-sm lg:gap-gap-element-md flex items-center justify-between rounded-xl",
                  // border
                  "border-indigo-lighter border transition-all hover:border-white",
                  // background gradient with smooth transitions
                  "relative bg-[linear-gradient(180deg,rgba(189,212,252,0.2)_0%,rgba(178,178,179,0.2)_100%)]",
                  "before:absolute before:inset-0 before:rounded-xl before:opacity-0 before:transition-opacity",
                  "before:bg-[linear-gradient(180deg,rgba(189,212,252,0.35)_0%,rgba(178,178,179,0.35)_100%)]",
                  "hover:before:opacity-100",
                )}
              >
                {item.media && (
                  <ResponsiveImage
                    src={item.media}
                    width={64}
                    height={64}
                    className="relative z-10 size-12 lg:size-16"
                    imageOptions={{ desktopWidth: 64 }}
                    useNextImage
                  />
                )}

                <div className="gap-gap-element-sm relative z-10 flex items-center">
                  <span className="typography-text-medium-medium text-white">
                    {item.linkCta.label}
                  </span>
                  <KeyboardArrowRight className="pointer-events-none size-6 shrink-0 fill-white" />
                </div>
              </div>
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
};
